import { ReactElement } from "react";
import AuthenticateStep from "./AuthenticateStep";
import ConnectionNameStep from "./ConnectionNameStep";
import MapAdministrationsStep from "./MapAdministrationsStep";
import MapVATCodesStep from "./MapVATCodesStep";
import SelectModulesStep from "./MapModulesStep";
import SynchronisationTimeStep from "./SynchronisationTimeStep";
import FinalOverviewStep from "./FinalOverviewStep";
import { ConnectionMapping } from "../../types";
import type { StepProps } from "./AddNewConnection";

export const WIZARD_STEP_COMPONENTS: ReactElement<StepProps>[] = [
  <AuthenticateStep />,
  <ConnectionNameStep />,
  <MapAdministrationsStep />,
  <SelectModulesStep />,
  <MapVATCodesStep />,
  <SynchronisationTimeStep />,
  <FinalOverviewStep />,
];

export const WIZARD_TOTAL_STEPS = WIZARD_STEP_COMPONENTS.length;

const MAP_VAT_CODES_STEP_INDEX = WIZARD_STEP_COMPONENTS.findIndex(
  (step) => step.type === MapVATCodesStep
);

export function isOnlyLoonSelected(mappings: ConnectionMapping[] = []): boolean {
  const journalMappings = mappings.filter((mapping) => mapping.type === "journal");
  return journalMappings.length > 0 && journalMappings.every((mapping) => mapping.source === "loon");
}

export function getWizardSkipIndices(mappings: ConnectionMapping[] = []): Set<number> {
  return isOnlyLoonSelected(mappings) ? new Set([MAP_VAT_CODES_STEP_INDEX]) : new Set();
}
